module.exports = __webpack_public_path__ + "img/speeder-frame.b7e3dadb.svg";